import type { ServiceCategoryRow } from '@/api/booking/getServiceCategoriesQuery';

interface GetVisibleL2CategoriesParams {
  l1Id: string;
  rows: ServiceCategoryRow[];
  counts: Map<string, number>;
}

export interface VisibleSubcategory {
  category: ServiceCategoryRow;
  count: number;
}

/**
 * Returns the visible L2 rows under `l1Id` that have at least one service,
 * with their counts, ordered by `position` then `id`.
 */
export function getVisibleL2Categories({
  l1Id,
  rows,
  counts,
}: GetVisibleL2CategoriesParams): VisibleSubcategory[] {
  return rows
    .filter((row) => row.parentCategoryId === l1Id && row.visible !== false)
    .map((category) => ({ category, count: counts.get(category.id) ?? 0 }))
    .filter(({ count }) => count > 0)
    .sort(
      (a, b) =>
        (a.category.position ?? 0) - (b.category.position ?? 0) ||
        (a.category.id < b.category.id
          ? -1
          : a.category.id > b.category.id
            ? 1
            : 0),
    );
}
